export default "__VITE_ASSET__DBWtH0w0__"